import React, { ReactNode, useCallback, useState } from 'react'
import styled from 'styled-components/macro'
import { transparentize } from 'polished'

import Popover, { PopoverProps } from './Popover'


export const TooltipContainer = styled.div`
  font-family: Montserrat-Light;
  font-size: 1.25rem;
  max-width: 256px;
  padding: 0.8rem 1.15rem;
  word-break: break-word;
  background: ${({ theme }) => theme.tooltipContainerBackgroundColor };
  border-radius: 18px;
  border: 1px solid ${({ theme }) => theme.tooltipContainerBorderColor };
  box-shadow: 0 4px 8px 0 ${({ theme }) => transparentize(0.9, theme.tooltipContainerBackgroundColor)};
`

interface TooltipProps extends Omit<PopoverProps, 'content'> {
  text: ReactNode
  disableHover?: boolean // disable the hover and content display
}

export default function Tooltip({ text, ...rest }: TooltipProps) {
  return <Popover content={text && <TooltipContainer>{text}</TooltipContainer>} {...rest} />
}

export function MouseoverTooltip({ text, disableHover, children, ...rest }: TooltipProps) {
  const [show, setShow] = useState(false)

  const open = useCallback(() => setShow(true), [setShow])
  const close = useCallback(() => setShow(false), [setShow])

  const handleMouseEnter = () => {
    setTimeout(() => {
      setShow(true)
    }, 30)
  }

  const handleMouseLeave = () => {
    setTimeout(() => {
        setShow(false)
    }, 1000)
  }

  return (
    <div onMouseEnter={open} onMouseLeave={close}>
      <Tooltip {...rest} show={show} text={disableHover ? null : text}>
        {children}
      </Tooltip>
    </div>
  )
}